export default __webpack_public_path__ + "static/news7-29995e58182d7be568fff4fd734c26d2.jpeg";